module.exports = __webpack_public_path__ + "img/content2.df9f35d9.png";